import { deepObjectMerge } from "@/util/utils.js";
import base from "./baseTH";
import table from "./tableTH";
import pages from "./pagesTH";
import common from "./commonTH";
import tips from "./tips";
import protocol from "./protocol.js";

export default deepObjectMerge(base, table, pages, common, tips, protocol);
